import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';


class IsThisYourEmail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            trigger: false,
            email: '',
        };
        this.triggetNext = this.triggetNext.bind(this);

    }
    componentDidMount() {
        const {store} = this.props;
        if (store.patient.email) {
            this.setState(
                {
                    trigger: true,
                    loading:false,
                    email:this.transformEmail(store.patient.email)
                }
                );
            this.triggetNext(true, 'yes_no_isThisIsYourEmail');
        } else {
            this.setState(
                {
                    trigger: true,
                    loading:false,
                    email:false
                }
            );
            this.triggetNext(false, 'please_contact_support');
        }
    }

    triggetNext(value, trigger) {
        this.setState({trigger: true});
        this.props.triggerNextStep({value: value, trigger: trigger})
    }

    transformEmail(email) {
        let parts = email.split("@"), len = parts[0].length;
        return email.replace(parts[0].slice(3), "*".repeat(3));
    }

    render() {
        const {step} = this.props;
        const {loading,email} = this.state;
        return (
            <div>

                {loading ? (
                    <Loading/>
                ) : (
                    email?(
                        <span>{step.metadata.message} <br/> {email} ?</span>
                    ):(
                        <span>{step.metadata.emailNotSpecifiedInAccount}</span>
                    )
                )}

            </div>
        );
    }

}

IsThisYourEmail.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

IsThisYourEmail.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default IsThisYourEmail;
